import './company.scss';
import 'slick-carousel';
export default () => {
	let $jsCompanySlider = $( '.js-company-slider' );

	$jsCompanySlider.slick( {
		rows: 0,
		dots: true,
		infinite: true,
		arrows: false,
		swipeToSlide: true,
		touchThreshold: 100,
	} );
};
